interface NativeScrollAreaProps {
  children: React.ReactNode;
}

export function NativeScrollArea({ children }: NativeScrollAreaProps) {
  return <>{children}</>;
}
